import ApiRequest from '@/plugins/axios'

export default {
  getList () {
    return ApiRequest.get('layer')
  },
  get (layerId) {
    return ApiRequest.get('layer/' + layerId)
  },
  delete (layerId) {
    return ApiRequest.delete('layer/' + layerId)
  },
  create (data) {
    return ApiRequest.post('layer', data)
      .then((response) => {
        return response.data.data
      }, (error) => {
        throw error
      })
  },
  update (layerId, data) {
    return ApiRequest.put('layer/' + layerId, data)
      .then((response) => {
        return response.data.data
      }, (error) => {
        throw error
      })
  },
  getColumns (layerId) {
    return ApiRequest.get('layer/columns/' + layerId)
  },
  /**
   * Get the field layout by ID
   *
   * @param {Number} fieldLayoutId
   * @return {AxiosPromise<any>}
   */
  getFieldLayout (fieldLayoutId, includeImmoScoutFields) {
    return ApiRequest.get('layer/field-layout/' + fieldLayoutId + (includeImmoScoutFields ? '?includeImmoscout=true' : ''))
  },
  getSearchOptions () {
    return ApiRequest.get('layer/search-options')
  },
  /**
   * @param {String} url
   * @return {AxiosPromise<any>}
   */
  previewWmsImport (url) {
    return ApiRequest.get('layer/preview-wms-layer?url=' + url)
  },
  /**
   * Saves a new WMS layer import
   *
   * @param {String} url
   * @param {String[]} layers
   * @return {AxiosPromise<any>}
   */
  createWmsImport (url, layers) {
    return ApiRequest.post('layer/save-wms-layer', {
      url: url,
      layers: layers
    })
  }
}
